import { createContext, useContext, useEffect, useState } from 'react';

import { ErrorPage, ReloadButton } from '@/shared/ui/ErrorPage';
import { FullPageLoader } from '@/shared/ui/Loading';

// check-sso waits on a hidden iframe to Keycloak; when the server is down that
// iframe never answers and keycloak-js neither resolves nor rejects.
export const AUTH_INIT_TIMEOUT_MS = 20_000;

// Set by Root when keycloak-js reports onInitError.
export const AuthInitFailedContext = createContext(false);

// Rendered while Keycloak is not initialised, instead of a blank page.
function AuthBootstrap() {
  const initFailed = useContext(AuthInitFailedContext);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setTimedOut(true), AUTH_INIT_TIMEOUT_MS);
    return () => clearTimeout(id);
  }, []);

  if (!initFailed && !timedOut) return <FullPageLoader />;

  return <ErrorPage variant="authUnavailable" fullScreen actions={<ReloadButton />} />;
}

export default AuthBootstrap;
